<template>
<div style="display: flex; flex-direction: row; align-items: flex-end;">
    <img class="logo" src="@/assets/logo.png"/>
    <el-menu :default-active="activeIndex" mode="horizontal" v-bind:router="true">
        <el-menu-item index="/upload">Upload Assets</el-menu-item>
        <el-menu-item index="/notes">Download Notes</el-menu-item>
        <!-- <el-menu-item index="/account">{{name}}</el-menu-item> -->
        <el-menu-item index="4" primary v-if="isAuthenticated" @click="logout" style="float: right;">
            <el-button type="text">Log out</el-button>
        </el-menu-item>
    </el-menu>
</div>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import { AUTH_LOGOUT } from "@/store/actions/auth";

export default {
  name: "navigation",
  data() {
    return {
      activeIndex: "/upload"
    };
  },
  methods: {
    logout: function() {
      this.$store.dispatch(AUTH_LOGOUT).then(() => this.$router.push("/login"));
    }
  },
  computed: {
    ...mapGetters(["getProfile", "isAuthenticated", "isProfileLoaded"]),
    ...mapState({
      authLoading: state => state.auth.status === "loading",
      name: state => `${state.user.profile.title} ${state.user.profile.name}`
    })
  }
};
</script>

<style lang="scss" scoped>
.logo {
  width: 38px;
  height: 38px;
  border-radius: 50%;
  margin: auto;
  margin-right: 22px;
}

.el-menu {
  flex: 1;
}
</style>
